// extracted by mini-css-extract-plugin
module.exports = {"Warining":"BlockWarning_Warining__gyS9-","Wrap":"BlockWarning_Wrap__8pS4f","Title":"BlockWarning_Title__adnV1","Message":"BlockWarning_Message__2M646"};